import * as Yup from "yup";

export const dataModel = {
  name: "",
  cif: "",
};

export const validationDataModel = Yup.object().shape({
  cif: Yup.string().optional(""),
  name: Yup.string().optional(""),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
